import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../util/assets';
import Button from '../../../../components/global/Button';
import { getFormikTouchedErrors } from '../../../../util/formik';
import PinField from '../../../../components/global/PinField';

const propTypes = {
  values: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  onEmailPinCodeRequest: PropTypes.func.isRequired,
  errors: PropTypes.object,
  touched: PropTypes.object,
  loading: PropTypes.bool,
  onGoBack: PropTypes.func,
  className: PropTypes.string,
};

const RegisterViewPinVerificationForm = ({
  values,
  handleSubmit,
  handleChange,
  onEmailPinCodeRequest,
  loading,
  errors,
  touched,
  onGoBack,
  className,
}) => {
  const [sendingEmail, setSendingEmail] = useState(false);

  const onSendEmail = () => {
    if (sendingEmail) {
      return;
    }

    setSendingEmail(true);

    try {
      onEmailPinCodeRequest(values.email_address);
    } catch (e) {
      //   Do nothing, the function catches by itself.
    } finally {
      setSendingEmail(false);
    }
  };

  const classes = classNames({
    'view-register-form': true,
    [className]: !!className,
  });
  const errorList = Object.values(
    getFormikTouchedErrors(errors, touched) ?? {},
  );

  return (
    <form className={classes} onSubmit={handleSubmit}>
      <div className="text-center mb-3">
        <img src={getAsset('/waldo-icon.svg')} alt="" width="56px" />
      </div>

      <p className="text-center text-light">
        Please verify your email by entering the PIN Code sent to:
        <br />
        <span className="text-primary">{values.email_address}</span>
      </p>
      <div className="mb-2 text-center">
        <PinField
          className="registration-pin-field registration-pin-input m-auto"
          onComplete={value => {
            handleChange({
              target: {
                name: 'pin_code',
                value,
              },
            });
          }}
          onChange={value => {
            handleChange({
              target: {
                name: 'pin_code',
                value,
              },
            });
          }}
        />
      </div>

      <div className="text-sm text-center">
        Didn&apos;t receive the email?
        <br />
        <Button
          btnStyle="link"
          btnSize="sm"
          onClick={onSendEmail}
          disabled={loading || sendingEmail}
        >
          {sendingEmail ? 'Sending pin code...' : 'Resend pin code'}
        </Button>
        {onGoBack && (
          <>
            &nbsp;or&nbsp;
            <Button
              btnStyle="link"
              btnSize="sm"
              onClick={onGoBack}
              disabled={loading || sendingEmail}
            >
              Change email
            </Button>
          </>
        )}
      </div>
      {errorList?.length > 0 && (
        <ul className="mb-2 text-danger text-center">
          {errorList.map(error => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      )}
      <div className="text-center mt-2">
        <Button type="submit" disabled={loading} loading={loading}>
          {loading ? 'Processing...' : 'Verify'}
        </Button>
      </div>
    </form>
  );
};

RegisterViewPinVerificationForm.propTypes = propTypes;
export default RegisterViewPinVerificationForm;
